import React from 'react'
import {connect} from "react-redux";
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Modal, Input, Button } from "antd";
import "./fogetPwd.less"
import {axios_} from "../../tools/axios_";
import {Patterns} from "../../tools/patterns";
/**
 * 忘记密码
 * @author  wuchao
 *
 */
let interval = null;//倒计时计时器
class ForgetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,//是否展示窗口
            ifVerification: true,//是否展示倒计时
            verificationValue: "重新发送",
            countDown: "120",//倒计时数据
            isExcuTimer: false,//是否执行倒计时（默认不执行）
            orgCode:"",//商户号
            username: "",//用户名
            password: "",//密码
            smsCode: "",//验证码
            mobilePhone:"",//手机号

        };
        if (props.onOk) {//确定事件的回调
            this.onOk = props.onOk;
        }
        if (props.onCancel) {//取消事件的回调
            this.onCancel = props.onCancel;
        }
    }

    /** 生命周期接受参数*/
    componentWillReceiveProps(props) {
        // console.log("isShowF: " + props.isShowF, " ,state: " + this.state.visible);
        if (props.isShowF === true){

            this.setState({visible: props.isShowF})
        }

    }
    handleSubmmit=()=>{
        axios_({
            url:"fogetpassword",
            method:"post",
            data:{
                orgCode:this.state.orgCode,//商户号
                username:this.state.username,//用户名
                password:this.state.password,//密码
                smsCode:this.state.smsCode,//手机号
                mobilePhone:this.state.mobilePhone,//手机号
            }
        }).then(res=>{
            if (res.data.status === 200){
                Modal.info({
                    title:"提示",
                    content:"密码修改成功",
                    onOk:()=>{
                        this.onOk();//回调
                        this.setState({visible:false,ifVerification:true},_=>{
                            this.props.form.resetFields();//重置所有数据
                        });
                    }
                })
            }else {
                Modal.info({
                    title:"提示",
                    content:res.data.message,
                    okText:"知道了",
                    // onOk:()=>{
                    //
                    //     this.props.form.resetFields();//重置所有数据
                    //
                    // }
                })
            }
        });
    };
    /** 执行发送短信接口*/
    doSendSMSCode=()=>{
        axios_({
            url:"sendSmsForUpdatePwd",
            method:"get",
            params:{
                orgCode:this.state.orgCode,//商户号
                mobilePhone:this.state.mobilePhone,//手机号
                username:this.state.username,//用户名
            }
        }).then(res=>{
            if (res.data.status === 200){
                Modal.info({
                    title:"提示",
                    content:res.data.message,
                });
                this.setState({ifVerification: false, isExcuTimer: true}, _ => {
                    this.excuCutdownTime();//倒计时
                })
            }else {
                Modal.info({
                    title:"提示",
                    content:res.data.message,
                });
            }
        });
    };

    /** 执行倒计时*/
    excuCutdownTime = () => {
        let num = 120;
        interval = setInterval(_ => {
            this.setState({countDown: --num});
            if (num <= 0) {
                clearInterval(interval);//清除倒计时
                this.setState({countDown: "重新发送"})
            }

        }, 1000)
    };

    render() {
        // console.log(this.props.isShowF)
        return (
            <div>
                <Modal

                    open={this.state.visible}
                    footer={null}
                    onOk={() => {
                        this.setState({visible: false}, _ => {
                            this.onOk && this.onOk()

                        });
                    }}

                    onCancel={() => {
                        this.setState({visible: false,ifVerification:true}, _ => {
                            this.onCancel && this.onCancel()
                            this.props.form.resetFields();//重置所有数据
                        });
                    }}
                >
                    <div className="fogetPwd">
                        <div className="fogetPwd_title">找回密码</div>
                        <Form className="fogetPwd_input">
                            <div className="fogetPwd_index">
                                <Form.Item
                                >
                                    {this.props.form.getFieldDecorator('orgCode', {
                                        initialValue: "",
                                        rules: [{
                                            required: true, message: '请输入正确的商户号',pattern: Patterns.pattern_username,
                                        }],
                                    })(
                                        <Input placeholder="商户号" onChange={e=>{
                                            this.setState({orgCode:e.target.value});
                                        }}/>
                                    )}
                                </Form.Item>
                            </div>
                            <div className="fogetPwd_index">
                                <Form.Item>
                                    {this.props.form.getFieldDecorator('username', {
                                        initialValue: "",
                                        rules: [{
                                            required: true, message: '请输入正确的用户名',pattern: Patterns.pattern_username,
                                        }],
                                    })(
                                        <Input placeholder="用户名" onChange={e=>{
                                            this.setState({username:e.target.value});
                                        }}/>
                                    )}
                                </Form.Item>
                            </div>
                            <div className="fogetPwd_index">
                                <Form.Item
                                >
                                    {this.props.form.getFieldDecorator('mobilePhone', {
                                        initialValue: "",
                                        rules: [{
                                            required: true, message: '请输入正确的手机号',pattern: Patterns.pattern_mobile
                                        }],
                                    })(
                                        <Input placeholder="手机号" onChange={e=>{
                                            this.setState({mobilePhone:e.target.value});
                                        }}/>
                                    )}
                                </Form.Item>
                            </div>
                            <div className="fogetPwd_index">
                                <Form.Item
                                >
                                    {this.props.form.getFieldDecorator('smsCode', {
                                        initialValue: "",
                                        rules: [{
                                            required: true, message: '请输入正确的手机验证码',pattern: Patterns.pattern_smsCode
                                        }],
                                    })(
                                        <Input placeholder="手机验证码" onChange={e=>{
                                            this.setState({smsCode:e.target.value});
                                        }}/>
                                    )}
                                </Form.Item>
                            </div>
                            <div className="fogetPwd_index">
                                <Form.Item
                                >
                                    {this.props.form.getFieldDecorator('password', {
                                        initialValue: "",
                                        rules: [{
                                            required: true, message: '新密码不正确(须同时包含字母和数字)',pattern: Patterns.pattern_newPassword
                                        }],
                                    })(
                                        <Input placeholder="请输入6~20位新密码" type="password" onChange={e=>{
                                            this.setState({password:e.target.value});
                                        }}/>
                                    )}
                                </Form.Item>
                            </div>
                            <div className="fogetPwd_index">
                                <Form.Item
                                >
                                    {this.props.form.getFieldDecorator('repeatPassword', {
                                        initialValue: "",
                                        rules: [{
                                            required: true, message: '新密码不正确(须同时包含字母和数字)',pattern: Patterns.pattern_newPassword
                                        }],
                                    })(
                                        <Input placeholder="请输入6~20位确认密码" type="password" />
                                    )}
                                </Form.Item>
                            </div>
                            {/*验证码*/}
                            <div>{

                                this.state.ifVerification ?
                                    <Button value={this.state.verificationValue} className="verification"
                                            onClick={() => {
                                                this.props.form.validateFields(["orgCode","mobilePhone","username"],{first:false},(err, values) => {
                                                    if (!err) {//如果校验通过，则进行下载
                                                        this.doSendSMSCode();
                                                    }
                                                })

                                            }}>获取验证码</Button>
                                    :
                                    <Button className="verification" disabled={false} onClick={() => {
                                        if (this.state.countDown === "重新发送") {
                                            this.doSendSMSCode();
                                        }

                                    }}>{this.state.countDown}</Button>



                            }
                            </div>

                        </Form>
                        <div className="fogetPwd_bottom">
                            <Button className="fogetPwd_btn" onClick={() => {
                                this.props.form.validateFields((err, values) => {
                                    if (!err) {
                                        if (values.password !== values.repeatPassword) {
                                            this.props.form.setFields({
                                                repeatPassword: {
                                                    value: values.repeatPassword,
                                                    errors: [new Error('密码输入不一致')],
                                                },
                                            });
                                            return;
                                        }
                                        this.handleSubmmit();//提交接口
                                    }
                                })
                            }}>确认</Button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

function MapState(props) {
    return {};
}

const WrappedForm = Form.create()(ForgetPassword);
export default connect(MapState)(WrappedForm)
